module.exports = __webpack_public_path__ + "img/banner_new_3.8a4c84ad.png";